import { FC } from 'react';

import useInquiryStatusById from '../../store/hooks/useInquiryStatusById';
import Status from '../Status/Status';

import { IInquiryStatusProps } from './InquiryStatus.interface';
import { getCustomIcon, getStatusIcon } from './utils';

const InquiryStatus: FC<IInquiryStatusProps> = ({ className, value }) => {
  const inquiryStatus = useInquiryStatusById(value);

  if (!inquiryStatus) return null;

  return (
    <Status className={className} icon={getStatusIcon(value)} customIcon={getCustomIcon(value)}>
      {inquiryStatus.name}
    </Status>
  );
};

export default InquiryStatus;
